/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingReviewAcceptRequest
 */
export interface FlightBookingReviewAcceptRequest {
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewAcceptRequest
   */
  reviewId: string;
  /**
   *
   * @type {number}
   * @memberof FlightBookingReviewAcceptRequest
   */
  generation: number;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewAcceptRequest
   */
  consentVersion: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewAcceptRequest
   */
  consentDigest: string;
}

/**
 * Check if a given object implements the FlightBookingReviewAcceptRequest interface.
 */
export function instanceOfFlightBookingReviewAcceptRequest(
  value: object
): value is FlightBookingReviewAcceptRequest {
  if (!("reviewId" in value) || value["reviewId"] === undefined) return false;
  if (!("generation" in value) || value["generation"] === undefined)
    return false;
  if (!("consentVersion" in value) || value["consentVersion"] === undefined)
    return false;
  if (!("consentDigest" in value) || value["consentDigest"] === undefined)
    return false;
  return true;
}

export function FlightBookingReviewAcceptRequestFromJSON(
  json: any
): FlightBookingReviewAcceptRequest {
  return FlightBookingReviewAcceptRequestFromJSONTyped(json, false);
}

export function FlightBookingReviewAcceptRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingReviewAcceptRequest {
  if (json == null) {
    return json;
  }
  return {
    reviewId: json["review_id"],
    generation: json["generation"],
    consentVersion: json["consent_version"],
    consentDigest: json["consent_digest"],
  };
}

export function FlightBookingReviewAcceptRequestToJSON(
  json: any
): FlightBookingReviewAcceptRequest {
  return FlightBookingReviewAcceptRequestToJSONTyped(json, false);
}

export function FlightBookingReviewAcceptRequestToJSONTyped(
  value?: FlightBookingReviewAcceptRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    review_id: value["reviewId"],
    generation: value["generation"],
    consent_version: value["consentVersion"],
    consent_digest: value["consentDigest"],
  };
}
